// apps/share-web/src/offline/apply-sync.ts
//
// Исполнение решения, которое принял `syncAction`. Модуль отвечает на вопрос
// «что при этом исходе происходит с хранилищем», и больше ни на какой: ни
// сети, ни DOM, ни часов здесь нет.
//
// ⚠️ ЗДЕСЬ ЖИВЁТ ВТОРАЯ ПОЛОВИНА ГЛАВНОГО ЗАМКА ВОЛНЫ.
//
// Первая половина — сигнатура `keysToDelete` (reconcile.ts): она принимает
// `TeamLibrary[]`, которого при отказе не существует, поэтому «результат
// отказа» туда передать нечем. Вторая половина — что сверка вообще
// ЗАПУСКАЕТСЯ только из ветки успеха: подделать успех можно пустым массивом,
// и пустой массив — осмысленный вход («человека убрали отовсюду»), а не
// отказ. Сверка после сетевого отказа стёрла бы библиотеку целиком, то есть
// сломала бы ровно то, ради чего волна делается.
//
// Почему это не строчка в main.ts. Проверять расположение вызова регуляркой
// по исходнику — ложный замок того класса, который записан как
// TD-260921-named-locks-that-do-not-exist: текст зелен, защиты нет. Вынесенное
// сюда решение закрывается поведенческим тестом, и мутация «звать сверку
// всегда, с пустым списком при отказе» его красит. В main.ts остаётся один
// вызов — проводка без правил.

import type { OfflineStore } from './offline-store.js';
import type { SyncAction } from './library-sync.js';
import { keysToDelete } from './reconcile.js';

export interface ApplySyncArgs {
  store: OfflineStore;
  /** Тот же человек, на которого создан `store`. Сверка всегда про одного. */
  userId: string;
  action: SyncAction;
}

export async function applySyncAction(args: ApplySyncArgs): Promise<void> {
  const { store, userId, action } = args;

  switch (action.kind) {
    case 'save-and-reconcile': {
      await store.saveLibrary(action.teams, action.at);
      const doomed = keysToDelete(await store.cachedKeys(), action.teams, userId);
      if (doomed.length) await store.del(doomed);
      return;
    }
    case 'wipe':
      // Ни один ответ сервера сюда не приводит — `syncAction` не возвращает
      // `wipe` даже на 401 (см. его шапку). Источник исхода только явный:
      // выход из аккаунта и кнопка «стереть офлайн-данные».
      await store.clearUser();
      return;
    case 'keep':
      // Ничего. Ни записи, ни сверки, ни единого удаления — это и есть замок.
      return;
  }
}
